// extracted by mini-css-extract-plugin
export default {"label":"StoreSelector-module__label--3VvpG"};